/**
 * Number of seconds before expiry to refresh the token.
 *
 * @type {number}
 */
export const AUTH_REFRESH_LEEWAY = 60 * 5;

export const zitadelGraphqlErrors = Object.freeze({
    PASSWORD_RESET_REQUIRED: "password-reset-required",
    INVALID_MFA_CODE: "invalid-mfa-code",
});

export const zitadelDisplayIdpNameMap: Readonly<Record<ZitadelIdpName, string>> = Object.freeze({
    "Azure SAML": "Azure",
    "Azure OIDC": "Azure",
    "Google": "Google",
});

export const FAILED_AUTHENTICATION_PARAM = "failed-authentication";
